module.exports = __webpack_public_path__ + "img/Background2.4cb22827.jpg";